import React, { useState } from "react";
import { Link } from "react-router-dom";
import juniorlogo1 from "assets/img/Juniorlogo1.png";
import briefcase from "assets/img/briefcase.png";
import exam from "assets/img/exam.png";

export default function IndexNavbar() {
  const [showMenu, setShowMenu] = useState(false);
  const [showWayOfLearningDropdown, setShowWayOfLearningDropdown] =
    useState(false);

  const handleMenuToggle = () => setShowMenu(!showMenu);
  const closeMenu = () => {
    setShowMenu(false);
    setShowWayOfLearningDropdown(false);
  };
  const handleWayOfLearningToggle = () =>
    setShowWayOfLearningDropdown(!showWayOfLearningDropdown);

  return (
    <section>
      <nav className="top-0 fixed z-10 w-full flex items-center justify-between lg:hidden md:block">
        <div className="bg-white overflow-hidden w-full pr-4 flex items-center justify-between">
          <div className="flex justify-between items-center w-full">
            <Link to="/homepage1">
              <img
                className="w-48 md:w-48 p-2"
                src={juniorlogo1}
                alt="Junior Logo"
              />
            </Link>
            <div
              className="text-black font-bold p-4 text-2xl rounded-xl cursor-pointer"
              onClick={handleMenuToggle}
            >
              ☰
            </div>
          </div>
        </div>

        {showMenu && (
          <>
            {/* Overlay */}
            <div
              className="bg-black opacity-50 fixed top-0 left-0 w-full h-full z-40"
              onClick={closeMenu}
            ></div>

            {/* Sidebar */}
            <div
              className={`bg-white text-black fixed top-0 right-0 h-full z-50 transition-transform duration-500 ${showMenu ? "translate-x-0" : "translate-x-full"
                }`}
              style={{
                width: window.innerWidth >= 768 ? "60%" : "100%",
              }}
            >
              <div className="flex justify-between py-4 px-6 items-center">
                <Link to="/homepage1">
                  <img className="w-40" src={juniorlogo1} alt="Junior Logo" />
                </Link>
                <div
                  onClick={closeMenu}
                  className="text-black font-semibold text-base cursor-pointer"
                >
                  ✕
                </div>
              </div>

              <ul className="flex flex-col py-2 px-4 space-y-2">
                <li className="py-4">
                  <Link
                    to="/ourstory"
                    className="text-base font-semibold text-black "
                  >
                    About Us
                  </Link>
                </li>

                <li className="py-4">
                  <Link
                    to="/entrepreneurial-preschool"
                    className="text-base font-semibold text-black"
                  >
                    Curriculum
                  </Link>
                </li>

                {/* <li className="py-4">
                  <Link
                    to="/faqs"
                    className="text-base font-semibold text-black"
                  >
                    FAQ
                  </Link>
                </li> */}

                <li className="py-4">
                  <Link
                    to="/career"
                    className="text-base font-semibold text-black"
                  >
                    Careers
                  </Link>
                </li>

                <li className="py-4">
                  <Link
                    to="/contact"
                    className="text-base font-semibold text-black"
                  >
                    Contact Us
                  </Link>
                </li>

                <div className="flex gap-4 mt-6">
                  <div>
                    <div className="">
                      <div className="flex items-center  gap-2 rounded  borderpeach  px-2 py-1">
                        <div>
                          <img className="w-4" src={exam} alt="Check Icon" />
                        </div>
                        <a href="/enroll-now">
                          <p className=" cursor-pointer text-sm font-semibold">
                            Admission
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="">
                      <div className="flex items-center  gap-2  rounded xl:px-4  px-2 py-1" style={{ background: '#0189A5' }}>
                        <img className="w-4" src={briefcase} alt="Check Icon" />
                        <a href="/become-partner">
                          <p className=" cursor-pointer text-sm font-semibold text-white">
                            Become A Partner
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </ul>
            </div>
          </>
        )}
      </nav>
    </section>
  );
}
